
import image from "../../images/shakeHands.png";
export default function SustainabilityPartnershipBanner() {
  return (
    <div className="relative w-full mt-20 max-w-[1200px] h-auto lg:h-[482px] min-h-[482px] bg-[#101928] rounded-[12px] mx-auto overflow-hidden lg:overflow-visible p-6 sm:p-10 lg:p-0">
      
      {/* Floating Partnership Tag Layer (Frame 2147228665) */}
      <div className="relative lg:absolute lg:left-[64px] lg:top-[48px] flex flex-row justify-center items-center px-[12px] py-[4px] w-[100px] h-[25px] bg-[rgba(123,194,22,0.25)] backdrop-blur-[12.5px] rounded-[8px] mb-6 lg:mb-0">
        <span className="text-[14px] font-medium text-[#0D924F] tracking-normal  leading-[17px] whitespace-nowrap">
          Partnerships
        </span>
      </div>

      {/* Content Canvas Layout Area (Frame 2147228667) */}
      <div className="relative lg:absolute lg:left-[64px] lg:top-[105px] flex flex-col items-start gap-[32px] w-full lg:w-[457px] h-auto lg:h-[329px] ">
        
        {/* Core Typography Block (Frame 2147228666) */}
        <div className="flex flex-col items-start gap-[16px] w-full lg:w-[457px] h-auto lg:h-[250px]">
          <h2 className="w-full text-[36px] sm:text-[42px] lg:text-[48px] font-medium text-white leading-[115%] lg:leading-[57px] ">
            Tap into the core of the <span className="text-[#0D924F]">Sustainability Economy.</span> 
          </h2>
          <p className="w-full text-[16px] sm:text-[18px] font-normal text-[#B1B1B1] leading-[21px] ">
            CloseCarbon offers high-visibility advertisement slots and sponsored content opportunities for brands looking to engage with verified corporate off setters.
          </p>
        </div>

        {/* Primary CTA Component Layer (Small buttons) */}
        <a href="/advert" className="flex flex-row justify-center items-center px-[14px] py-[12px] w-[170px] h-[47px] bg-[#0D924F] border-2 border-[#006633] rounded-[8px] transition-all hover:bg-[#0b7c43] active:scale-95 group duration-200">
          <span className="w-[154px] h-[23px] text-[16px] font-medium text-white leading-[145%] text-center font-['Inter'] font-feature-settings-['cv01','cv03','cv04'] select-none">
           Advertise with us
          </span>
          {/* Arrow 2 specification dictates display: none */}
          <span className="hidden w-[18px] border border-white ml-1 transition-transform group-hover:translate-x-1" />
        </a>
      </div>

      {/* Featured Side Image Composition (d729dd5248143e120ca299cf3d448f9f 1) */}
      <img
      src={image}
       alt="Sustainability Partnership" 
        className="relative lg:absolute w-full lg:w-[484px] h-[320px] sm:h-[400px]  lg:left-[648px] lg:top-[49px] bg-cover bg-center rounded-[24px]  mt-8 lg:mt-0"
      
      />
    </div>
  );
}